export const BLOCK_GAP = 16
export const BLOCK_HEIGHT = 24
export const BLOCK_COLUMNS = 4
export const DEFAULT_WIDTH = 480
export const MAX_WIDTH = 643
